import { useDispatch } from "react-redux";
// テストを始める（ヘッダーの「テスト」と公開準備パネルの「テスト」）。
// 前の区切りから中身が変わっていれば、いまの画面を撮って「テストした」の区切りを残してからプレビューへ移る
import { useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "app/store";
import { PieceMilestone } from "features/builder/types";
import { useBuilderScene } from "features/builder/context";
import { flushPendingMilestones, recordMilestoneWithCapture } from "features/builder/hook";

export const useStartTest = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const scene = useBuilderScene();
  // 撮っているあいだに もう一度押されても、区切りを 2 つ残さない
  const starting = useRef(false);

  return useCallback(async () => {
    if (starting.current) return;
    starting.current = true;
    dispatch(flushPendingMilestones());
    await dispatch(recordMilestoneWithCapture(scene, PieceMilestone.TEST));
    // ?from=test が無いと クリア画面が「いちらんに もどる」になる
    navigate("preview?from=test");
    starting.current = false;
  }, [dispatch, navigate, scene]);
};
